<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()

  import congrats from "@images/courses/congrats.jpg"

  let step_content = course_progress.substep_data.content
</script>

{#if step_content == "step1/welcome"}
  <p class="text-center text-3xl text-bold">Welcome</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Congratulations on starting the Effective Meetings Course. This course
      distills Marc Koehler’s 30+ years of running engaging and productive
      meetings as an Officer in the US Nuclear Submarine and as a Turnaround CEO
      for thousands of business.
    </p>

    <p class="mt-6 text-lg">
      In this course you will learn exactly how to run the six different types
      of meetings that will help your team build your culture, track your
      progress, manage change together, and execute your One Page Alignment Plan
      with discipline.
    </p>
    <p class="mt-6 text-lg">
      Just follow the step-by-step approach outlined in this online course to
      access all of the valuable videos, guides, instructional materials, and
      examples.
    </p>
    <p class="mt-6 text-lg text-bold">You can do this!</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387550998"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step1/meeting_basics"}
  <p class="text-center text-3xl text-bold">Meeting Basics</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Whether you are running a 15 minute daily standup meeting or an All-Day
      Annual Transition meeting, there are a set of standard meeting basics that
      make each one productive and impactful. This video addresses the top
      meeting challenges and frustrations. It then shares with you the
      ingredients needed to run an effective meeting.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387554092"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step2/intro"}
  <p class="text-center text-3xl text-bold">Daily Standup Meeting</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I will teach you everything you need to run a Daily Standup Meeting. I
      initially learned of the importance of this meeting as an Officer in the
      US Nuclear Submarine Force where information needed to travel up and down
      the chain of command in an efficient and effective manner.
    </p>
    <p class="mt-6 text-lg">
      Download the Daily Meeting Agenda (Click on <strong
        >Download Assets</strong
      >) and use it as a guide as you proceed through this section of the
      course.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387554440"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step3/introduction"}
  <p class="text-center text-3xl text-bold">Weekly Leadership Meeting</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I will teach you everything you need to run the Weekly Leadership Meeting.
      This one hour meeting helps the team come together to give an update on
      the status of the quarterly goals and then collectively work with each
      other to overcome an obstacle or solve a problem that is holding the
      company back in the short-term.
    </p>
    <p class="mt-6 text-lg">
      Download the Weekly Meeting Agenda (click on <strong
        >Download Assets</strong
      >) and use it as a guide as you proceed through this section of the
      course.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387556776"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step4/introduction"}
  <p class="text-center text-3xl text-bold">Monthly All-Hands Meeting</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I will teach you everything you need to run the Monthly All-Hands meeting
      where you bring the entire company together to communicate directly with
      every employee. The All-Hands meetings we held in the submarine force
      helped everyone to hear directly from the Captain the status of the
      mission while celebrating achievements in front of the entire crew.
    </p>
    <p class="mt-6 text-lg">
      Download the Monthly Meeting Template (click on <strong
        >Download Assets</strong
      >) and use it as a guide as you proceed through this section of the
      course.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387556894"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step5/introduction"}
  <p class="text-center text-3xl text-bold">Quarterly Transition Meeting</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I will teach you everything you need to run the Quarterly Transition
      Meeting which is a half-day together with your team to reflect upon your
      accomplishments in the current quarter while getting laser focused on next
      quarter’s new and exciting goals.
    </p>
    <p class="mt-6 text-lg">
      The Quarterly Transition Checklist and Agenda, located in the <strong
        >Download Assets</strong
      >
      panel, are the two key resources you will use.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387557037"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step6/introduction"}
  <p class="text-center text-3xl text-bold">Annual Transition Meeting</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I will teach you everything you need to run the Annual Transition Meeting
      which is a full day together with your team to reflect upon your
      accomplishments in the current year while getting laser focused on next
      year’s new and exciting goals.
    </p>
    <p class="mt-6 text-lg">
      The Annual Transition Checklist and Agenda, located in the <strong
        >Download Assets</strong
      > panel, are the two key resources you will use.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387557315"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step7/overview"}
  <p class="text-center text-3xl text-bold">Impromptu Meetings</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I will teach you everything you need to run an Impromptu Meeting which
      will help you to quickly bring together only the necessary people to
      discuss an issue that is more tactical in nature and get it resolved or
      create a plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387557424"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step8/recap"}
  <p class="text-center text-3xl text-bold">Recap</p>
  <div class="px-12">
    <p class="mt-6 text-lg">
      I hope you can clearly see how the meeting structure will help you to
      bring your One Page Success Plan to life in a productive and meaningful
      way. This entire meeting structure will keep your team focused on what
      matters most, help you to execute with discipline, and strengthen your
      culture.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/387557487"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E2 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "step8/congratulations"}
  <div class="px-6 pb-12">
    <img
      src={congrats}
      class="mt-8 max-w-3xl mx-auto rounded-t-lg"
      alt="Congratulations"
    />
    <div class="max-w-3xl mx-auto">
      <p class="text-xl bg-blue-900 text-white rounded-b-lg shadow p-8">
        Congratulations on completing the Effective Meetings Course! Now is a
        great time to take a look at our additional courses which help you put
        simple & powerful systems in place so you can continue empowering your
        employees.
      </p>
    </div>
  </div>
{/if}
